<div [formGroup]="formGroup">
	<mat-slide-toggle
		formControlName="acceptEmailOffers"
		color="accent"
		[checked]="formGroup?.value.acceptEmailOffers"
		(change)="change.emit('acceptEmailOffers')"
		>{{ "marketing-notification.emailOffer" | translate }}</mat-slide-toggle
	>
	<mat-slide-toggle
		formControlName="acceptSmsOffers"
		color="accent"
		[checked]="formGroup?.value.acceptSmsOffers"
		(change)="change.emit('acceptSmsOffers')"
		>{{ "marketing-notification.smsOffer" | translate }}</mat-slide-toggle
	>
	<mat-slide-toggle
		formControlName="acceptTelesalesOffers"
		color="accent"
		[checked]="formGroup?.value.acceptTelesalesOffers"
		(change)="change.emit('acceptTelesalesOffers')"
		>{{ "marketing-notification.teleSalesOffer" | translate }}</mat-slide-toggle
	>
</div>
